import type { Icon } from "@phosphor-icons/react";
import {
  Bell,
  ChartBar,
  ClipboardText,
  Cube,
  DeviceMobile,
  Gear,
  ShieldCheck,
  SquaresFour,
} from "@phosphor-icons/react";

export interface AdminRoute {
  path: string;
  label: string;
  description: string;
  icon: Icon;
  permission?: string;
  tenantAdminOnly?: boolean;
  group: "设备运营" | "治理分析" | "平台配置";
}

export const adminRoutes: AdminRoute[] = [
  {
    path: "/overview",
    label: "设备总览",
    description: "企业设备运行状态和异常处置入口",
    icon: SquaresFour,
    permission: "devices:read",
    group: "设备运营",
  },
  {
    path: "/devices",
    label: "设备管理",
    description: "管理设备绑定、分组、状态和运维动作",
    icon: DeviceMobile,
    permission: "devices:read",
    group: "设备运营",
  },
  {
    path: "/tasks",
    label: "任务管理",
    description: "创建、审批并追踪设备任务",
    icon: ClipboardText,
    permission: "tasks:read",
    group: "设备运营",
  },
  {
    path: "/policies",
    label: "策略管理",
    description: "管理设备运行和任务审批策略",
    icon: ShieldCheck,
    tenantAdminOnly: true,
    group: "治理分析",
  },
  {
    path: "/applications",
    label: "应用管理",
    description: "查看应用清单并控制版本发布",
    icon: Cube,
    tenantAdminOnly: true,
    group: "平台配置",
  },
  {
    path: "/audit",
    label: "合规审计",
    description: "追踪敏感操作、访问和导出记录",
    icon: ShieldCheck,
    permission: "audit:read",
    group: "治理分析",
  },
  {
    path: "/alerts",
    label: "告警中心",
    description: "确认、处置并关闭运行告警",
    icon: Bell,
    permission: "alerts:read",
    group: "治理分析",
  },
  {
    path: "/reports",
    label: "报表中心",
    description: "分析设备、任务和告警趋势",
    icon: ChartBar,
    permission: "tasks:read",
    group: "治理分析",
  },
  {
    path: "/settings",
    label: "系统设置",
    description: "管理企业、成员、权限和开放集成",
    icon: Gear,
    tenantAdminOnly: true,
    group: "平台配置",
  },
];
